import { Injectable } from '@angular/core';
import { Adapter } from '../../../../interfaces/Adapter';
import { JobDefinitionResponse } from '../../../../interfaces/response/AdminPageResponses';

/**
 * An adapter converts job log HTTP response to domain object.
 */
@Injectable({
  providedIn: 'root'
})
export class JobDefinitionAdapter implements Adapter<string> {

  /**
   * Converts job definition HTTP response to {@link string}.
   * @param item job definition HTTP response.
   */
  adapt(item: JobDefinitionResponse): string {
    return item.jobDefinition;
  }
}
